import moment from 'moment';
import React, {useEffect, useState} from 'react';
import DatePicker from 'react-datepicker';

import './index.scss';
import {useTranslation} from '../../hooks/useTranslation';
export default function Datepicker({
  value,
  setValue,
  type,
  width = '100%',
  keys,
  minDate = null,
  maxDate = null,
  readOnly,
}) {
  const {t} = useTranslation();
  const [date, setDate] = useState(value ? moment(value)?.toDate() : null);
  useEffect(() => {
    setDate(value ? moment(value)?.toDate() : null);
  }, [value]);
  return (
    <div className='c-datepicker' style={{width: width}}>
      <DatePicker
        readOnly={readOnly}
        selected={date}
        isClearable={!readOnly}
        key={keys}
        onChange={selected => {
          setValue(selected);
          setDate(selected);
        }}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={
          type === 'from'
            ? t('datepicker.dateFrom')
            : type === 'to'
              ? t('datepicker.dateTo')
              : t('datepicker.selectDate')
        }
        showIcon={!date}
        icon={
          <span>
            <img src='/assets/icons/calendar.svg' alt='calendar' />
          </span>
        }
      />
    </div>
  );
}
